import { render, staticRenderFns } from "./Clean.vue?vue&type=template&id=0b60d594&scoped=true&"
var script = {}
import style0 from "./Clean.vue?vue&type=style&index=0&id=0b60d594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60d594",
  null
  
)

export default component.exports